import React from 'react';
import {
  Component,
  ExpressionPath,
  Plugins,
  TypeImplementation,
} from '@packages/systems/wfdl';
import {
  ExpressionEditor,
  extendExpressionEditorActionAtPath,
} from '@packages/systems/ExpressionEditor-utils';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {reportBug} from '@packages/utilities/reporter';
import {findComponentPath} from '../utils';
import {qualify} from '@packages/systems/wfdl-Qualified';

import {
  ContextualExpressions,
  stripAll,
} from '@packages/utilities/contextual-expression';

const {getIn} = ContextualExpressions;

const FormFormChildrenType = TypeImplementation.Alias({
  type: TListOfElement,
  render: function RenderFormFormChildren({expr, dispatch}) {
    const strippedExpr = stripAll(expr);
    const formFormPath = findComponentPath(
      strippedExpr,
      qualify(Plugins.name('Form'), Component.name('FormForm'))
    );

    if (!formFormPath || formFormPath.length < 1) {
      reportBug(
        'FormFormNotFoundInFormWrapper',
        'Form Form has not been found in Form Wrapper',
        {
          expr: strippedExpr,
          team: 'platform',
          ticket: 'https://webflow.atlassian.net/browse/PLAT-1059',
        }
      );
      return null;
    }
    const path = [...formFormPath, {in: 'Element'}] satisfies ExpressionPath;
    const formFormData = getIn(expr, path);
    if (!formFormData) return null;
    const onChange = extendExpressionEditorActionAtPath(dispatch)(path);

    return <ExpressionEditor expression={formFormData} dispatch={onChange} />;
  },
});

export default FormFormChildrenType;
